<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size:15px; font-weight: bold">update importer</small>
      </legend>
      <div>
        <form @submit.prevent="importerUpdate()">
          <div class="row">
            <div class="col-md-6">
              <input type="hidden" class="id" :value="Importer.id" />
              <div class="form-group">
                <label>Importer name</label>
                <input
                  type="text"
                  class="form-control importer_name"
                  :value="Importer.importer_name"
                  placeholder="importer name"
                  required
                />
              </div>
              <div class="form-group">
                <label>Mobile number</label>
                <input
                  type="number"
                  class="form-control mobile_number"
                  :value="Importer.mobile_number"
                  placeholder="mobile number"
                  required
                />
              </div>
              <div class="form-group">
                <label>Marketer name</label>
                <input
                  type="text"
                  class="form-control marketer_name"
                  :value="Importer.marketer_name"
                  placeholder="marketer name"
                  required
                />
              </div>
              <div class="form-group">
                <label>Country</label>
                <input
                  type="text"
                  class="form-control country"
                  :value="Importer.country"
                  placeholder="country"
                  required
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Email address</label>
                <input
                  type="email"
                  class="form-control email_address"
                  :value="Importer.email_address"
                  placeholder="email address"
                  required
                />
              </div>
              <div class="form-group">
                <label>Address</label>
                <input
                  type="text"
                  class="form-control address"
                  :value="Importer.address"
                  placeholder="address"
                  required
                />
              </div>
              <div class="form-group">
                <label>City</label>
                <input
                  type="text"
                  class="form-control city"
                  :value="Importer.city"
                  placeholder="city"
                  required
                />
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary btn-flat updatingImporter btn-rounded">
            <i class="fa fa-refresh"></i> update importer
          </button>
          <button type="button" class="btn btn-primary btn-flat updatingImporterLoader btn-rounded">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import router from "../router/index"
export default {
    created(){
        if (this.$store.getters.Importer.length === 0) {
            router.push('/manageimporters');
        }
    },
    computed: {
        ...mapGetters(["Importer"])
    },
    methods: {
        ...mapActions(["importerUpdate"])
    }
    
}
</script>
<style scoped>
.updatingImporterLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/importers/updateimporter.vue